import { Link, useParams } from 'react-router-dom'
import { useStack } from '@/lib/cluster'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { StatusBadge } from '@/components/StatusBadge'
import { Skeleton } from '@/components/ui/skeleton'

export function StackDetailPage() {
  const { name } = useParams<{ name: string }>()
  const { data, isLoading } = useStack(name)

  return (
    <div className="space-y-6">
      <div>
        <Link to="/stacks" className="text-sm text-muted-foreground hover:underline">
          ← Back to stacks
        </Link>
        <h1 className="text-3xl font-bold tracking-tight">{data?.stack ?? name}</h1>
      </div>

      {isLoading && <Skeleton className="h-48" />}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data?.services.map((s) => (
          <Link key={s.id} to={`/services/${s.id}`} className="block">
            <Card className="h-full hover:border-primary/50 transition cursor-pointer">
              <CardHeader className="flex-row items-center justify-between pb-2">
                <CardTitle className="text-base">{s.name}</CardTitle>
                <StatusBadge status={s.status} />
              </CardHeader>
              <CardContent className="text-xs text-muted-foreground space-y-1">
                <div>{s.image ?? '—'}</div>
                <div>Type: {s.classification_override ?? s.classification_auto ?? 'unknown'}</div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
